// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Post Detail Container */
.post-detail-container {
  width: 100%;
  background: var(--bg-primary);
  min-height: 100vh;
  padding-top: 0;
}

/* Distraction-less Mode Toggle */
.distraction-less-toggle {
  position: fixed;
  top: 80px;
  right: 20px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@media (max-width: 1024px) {
  .distraction-less-toggle.desktop-only {
    display: none !important;
  }
}

.distraction-less-toggle:hover {
  background: var(--accent-primary);
  color: white;
  border-color: var(--accent-primary);
  transform: scale(1.1);
}

.distraction-less-toggle svg {
  width: 24px;
  height: 24px;
}

/* Distraction-less Mode Styles */
.post-detail-container.distraction-less .article-wrapper {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.post-detail-container.distraction-less .article-back-nav {
  display: none;
}

/* Back navigation */
.article-back-nav {
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.article-back-nav .back-link {
  display: inline-block;
  padding: 10px 16px;
  color: var(--accent-primary);
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.back-link:hover {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
  padding-left: 20px;
}

/* Main article wrapper */
.article-wrapper {
  display: block;
  max-width: 1400px;
  margin: 0 auto;
}

.article-main {
  min-width: 0; /* Prevent overflow */
}

/* Parent Post Preview */
.parent-post-preview {
  padding: 16px;
  border-left: 4px solid var(--primary-color);
  background-color: var(--bg-secondary);
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-left-color 0.2s ease;
}

.parent-post-preview:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-left-color: var(--accent-primary);
}

.parent-post-preview-header {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.parent-post-preview-author {
  font-weight: bold;
  color: var(--text-primary);
}

.parent-post-preview-link {
  text-decoration: none;
  color: var(--text-primary);
  display: block;
}

.parent-body-preview {
  font-size: 1rem;
  line-height: 1.5;
  opacity: 0.9;
  color: var(--text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Article Footer */
.article-footer {
  max-width: min(750px, 53vw);
  margin: 60px auto 40px;
  padding: 40px 20px;
  border-top: 8px solid var(--border-color);
  text-align: center;
}

.article-footer-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  flex-direction: column;
}

.article-footer-via-app {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.article-footer-via-app em {
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article-footer-sourced {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9rem;
  color: var(--text-secondary);
}

.article-footer-sourced em {
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article-footer-community-title {
  margin-right: 0;
}

.article-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.article-action-btn {
  padding: 12px 20px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.article-action-btn:hover {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: white;
  transform: translateY(-2px);
}

.view-on-dropdown-container {
  position: relative;
  display: inline-block;
}

.view-on-dropdown {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 100;
  min-width: 150px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.view-on-link {
  color: var(--text-primary);
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s;
  text-align: center;
}

.view-on-link:hover {
  background-color: var(--bg-tertiary);
  color: var(--accent-primary);
}

.article-footer .article-tags {
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 24px;
}

.article-footer .article-actions-bar {
  margin-bottom: 18px;
  align-items: center;
  justify-content: center;
}

.article-footer .tag-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-right: 12px;
}

/* Error box */
.error-box {
  max-width: 600px;
  margin: 60px auto;
  padding: 40px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-left: 4px solid var(--error-color, #e74c3c);
  border-radius: 12px;
  text-align: center;
}

.error-box h2 {
  color: var(--text-primary);
  margin-bottom: 16px;
  font-size: 1.5rem;
}

.error-box p {
  color: var(--text-secondary);
  margin-bottom: 24px;
  font-size: 1rem;
}

/* Responsive design */
@media (max-width: 1200px) {
  .article-wrapper {
    padding: 0 0 40px;
  }

  .distraction-less-toggle {
    top: 70px;
    right: 12px;
    width: 44px;
    height: 44px;
  }

  .distraction-less-toggle svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 1159.9px) {
  .article-footer {
    max-width: 70vw;
  }
}

@media (max-width: 768px) {
  .post-detail-container {
    padding-top: 0;
  }

  .article-back-nav {
    padding: 16px 16px;
    margin-bottom: 16px;
  }

  .back-link {
    padding: 8px 12px;
    font-size: 0.95rem;
  }

  .article-wrapper {
    padding: 0 0 30px;
  }

  .article-footer {
    max-width: 100%;
    margin: 40px 0 20px;
    padding: 24px 16px;
  }

  .article-actions {
    gap: 12px;
  }

  .article-action-btn {
    flex: 1 1;
    min-width: 140px;
  }
}

@media (max-width: 640px) {
  .article-back-nav {
    padding: 12px 16px;
  }

  .back-link {
    padding: 6px 10px;
    font-size: 0.9rem;
  }

  .article-actions {
    flex-direction: column;
  }

  .article-action-btn {
    width: 100%;
  }

  .error-box {
    margin: 40px 16px;
    padding: 24px;
  }
  .view-on-dropdown-container {
    width: 100%;
    display: block;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .article-wrapper,
  .back-link,
  .article-action-btn {
    transition: none;
  }
}

/* Print styles */
@media print {
  .post-detail-container {
    padding: 0;
    background: white;
  }

  .article-back-nav,
  .article-footer {
    display: none;
  }

  .article-wrapper {
    max-width: 100%;
    padding: 0;
  }

  .article-main {
    color: black;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PostDetail.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY,EAAE,qBAAqB;AACrC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2CAA2C;EAC3C,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,kDAAkD;EAClD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA,kBAAkB;AAClB;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Post Detail Container */\r\n.post-detail-container {\r\n  width: 100%;\r\n  background: var(--bg-primary);\r\n  min-height: 100vh;\r\n  padding-top: 0;\r\n}\r\n\r\n/* Distraction-less Mode Toggle */\r\n.distraction-less-toggle {\r\n  position: fixed;\r\n  top: 80px;\r\n  right: 20px;\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 999;\r\n  transition: all 0.3s;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .distraction-less-toggle.desktop-only {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.distraction-less-toggle:hover {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border-color: var(--accent-primary);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.distraction-less-toggle svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n/* Distraction-less Mode Styles */\r\n.post-detail-container.distraction-less .article-wrapper {\r\n  max-width: 80%;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.post-detail-container.distraction-less .article-back-nav {\r\n  display: none;\r\n}\r\n\r\n/* Back navigation */\r\n.article-back-nav {\r\n  padding: 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  max-width: 1400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.article-back-nav .back-link {\r\n  display: inline-block;\r\n  padding: 10px 16px;\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  border-radius: 6px;\r\n  transition: all 0.2s;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.back-link:hover {\r\n  background: var(--bg-secondary);\r\n  border-color: var(--accent-primary);\r\n  padding-left: 20px;\r\n}\r\n\r\n/* Main article wrapper */\r\n.article-wrapper {\r\n  display: block;\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.article-main {\r\n  min-width: 0; /* Prevent overflow */\r\n}\r\n\r\n/* Parent Post Preview */\r\n.parent-post-preview {\r\n  padding: 16px;\r\n  border-left: 4px solid var(--primary-color);\r\n  background-color: var(--bg-secondary);\r\n  border-radius: 0 8px 8px 0;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-left-color 0.2s ease;\r\n}\r\n\r\n.parent-post-preview:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  border-left-color: var(--accent-primary);\r\n}\r\n\r\n.parent-post-preview-header {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.parent-post-preview-author {\r\n  font-weight: bold;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.parent-post-preview-link {\r\n  text-decoration: none;\r\n  color: var(--text-primary);\r\n  display: block;\r\n}\r\n\r\n.parent-body-preview {\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  opacity: 0.9;\r\n  color: var(--text-secondary);\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Article Footer */\r\n.article-footer {\r\n  max-width: min(750px, 53vw);\r\n  margin: 60px auto 40px;\r\n  padding: 40px 20px;\r\n  border-top: 8px solid var(--border-color);\r\n  text-align: center;\r\n}\r\n\r\n.article-footer-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-bottom: 16px;\r\n  flex-wrap: wrap;\r\n  flex-direction: column;\r\n}\r\n\r\n.article-footer-via-app {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  max-width: 260px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.article-footer-via-app em {\r\n  font-style: italic;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.article-footer-sourced {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  max-width: 260px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.article-footer-sourced em {\r\n  font-style: italic;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.article-footer-community-title {\r\n  margin-right: 0;\r\n}\r\n\r\n.article-actions {\r\n  display: flex;\r\n  gap: 16px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.article-action-btn {\r\n  padding: 12px 20px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  text-decoration: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.article-action-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.view-on-dropdown-container {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.view-on-dropdown {\r\n  position: absolute;\r\n  bottom: calc(100% + 8px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  padding: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  z-index: 100;\r\n  min-width: 150px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n}\r\n\r\n.view-on-link {\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n  text-align: center;\r\n}\r\n\r\n.view-on-link:hover {\r\n  background-color: var(--bg-tertiary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.article-footer .article-tags {\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-bottom: 2px solid var(--border-color);\r\n  padding-bottom: 24px;\r\n}\r\n\r\n.article-footer .article-actions-bar {\r\n  margin-bottom: 18px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.article-footer .tag-title {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-right: 12px;\r\n}\r\n\r\n/* Error box */\r\n.error-box {\r\n  max-width: 600px;\r\n  margin: 60px auto;\r\n  padding: 40px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-left: 4px solid var(--error-color, #e74c3c);\r\n  border-radius: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.error-box h2 {\r\n  color: var(--text-primary);\r\n  margin-bottom: 16px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.error-box p {\r\n  color: var(--text-secondary);\r\n  margin-bottom: 24px;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Responsive design */\r\n@media (max-width: 1200px) {\r\n  .article-wrapper {\r\n    padding: 0 0 40px;\r\n  }\r\n\r\n  .distraction-less-toggle {\r\n    top: 70px;\r\n    right: 12px;\r\n    width: 44px;\r\n    height: 44px;\r\n  }\r\n\r\n  .distraction-less-toggle svg {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1159.9px) {\r\n  .article-footer {\r\n    max-width: 70vw;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .post-detail-container {\r\n    padding-top: 0;\r\n  }\r\n\r\n  .article-back-nav {\r\n    padding: 16px 16px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .back-link {\r\n    padding: 8px 12px;\r\n    font-size: 0.95rem;\r\n  }\r\n\r\n  .article-wrapper {\r\n    padding: 0 0 30px;\r\n  }\r\n\r\n  .article-footer {\r\n    max-width: 100%;\r\n    margin: 40px 0 20px;\r\n    padding: 24px 16px;\r\n  }\r\n\r\n  .article-actions {\r\n    gap: 12px;\r\n  }\r\n\r\n  .article-action-btn {\r\n    flex: 1;\r\n    min-width: 140px;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .article-back-nav {\r\n    padding: 12px 16px;\r\n  }\r\n\r\n  .back-link {\r\n    padding: 6px 10px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .article-actions {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .article-action-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .error-box {\r\n    margin: 40px 16px;\r\n    padding: 24px;\r\n  }\r\n  .view-on-dropdown-container {\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* Accessibility */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .article-wrapper,\r\n  .back-link,\r\n  .article-action-btn {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n/* Print styles */\r\n@media print {\r\n  .post-detail-container {\r\n    padding: 0;\r\n    background: white;\r\n  }\r\n\r\n  .article-back-nav,\r\n  .article-footer {\r\n    display: none;\r\n  }\r\n\r\n  .article-wrapper {\r\n    max-width: 100%;\r\n    padding: 0;\r\n  }\r\n\r\n  .article-main {\r\n    color: black;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
